import React from 'react';
import MetaHead from '../components/meta-head';
import RegisterForm from '../features/authentication/forms/RegisterForm';
import AuthLayout from '../features/authentication/layout/AuthLayout';
const login = () => {
  return <div data-sentry-component="login" data-sentry-source-file="register.tsx">
      <MetaHead title="Create Your Account - PicknFix" description="Register with PicknFix to start protecting and repairing your devices. Simple and fast registration process for all your gadget insurance needs." data-sentry-element="MetaHead" data-sentry-source-file="register.tsx" />
      <AuthLayout heading="Personal Details" data-sentry-element="AuthLayout" data-sentry-source-file="register.tsx">
        <RegisterForm data-sentry-element="RegisterForm" data-sentry-source-file="register.tsx" />
      </AuthLayout>
    </div>;
};
export async function getStaticProps() {
  return {
    props: {}
  };
}
export default login;